import React from "react";
import Sales from "../components/Contact/sales-enquiry"; 
import Banner from '../comman/Banner/Banner';


const Salesenquire = () => {
  return (
    <>
    <Banner 
     index={'react-sales'}
    />
    <Sales/>    
    </>

  )
};

export default Salesenquire;